export default __webpack_public_path__ + "static/media/referral-stars.3e3b0bb5.svg";